import React from 'react'
import BiddingContractSubstep from "./BiddingContractSubstep";
import BiddingContractApprovalDocumentsSubstep from "./BiddingContractApprovalDocumentsSubstep";

export default class BiddingContractSummarySubstep extends BiddingContractSubstep
{
    static SubstepName = 'Final Approval';
    // static SubstepName = 'start_project.contract_schedule.title';

    static SubstepSlug = 'final-approval';
    static path = '/final-approval';

    static StepTitle = 'Final Approval';


	constructor(props) {
        super(props);

        this.state = {
            ...this.state
        }
    }


    renderStepContent()
    {
        let { project, canEditSOWForProject } = this.props;

        let steps = TB.filter(project.sowSteps(), step => {
            return step !== BiddingContractSummarySubstep &&
                step !== BiddingContractApprovalDocumentsSubstep
        });

        return (
            <div className="sow-summary-step">


                <div className="approve-summary-highlight">


                    <p>
                        Review the project information and make sure all details are correct.
                    </p>

                    <div className="items-start flex">
                        <button 
                            type="button" 
                            onClick={() => {
                                if (!canEditSOWForProject) {
                                    return TB.showPermissionError();
                                }
                                this.props.approveStep();
                            }}
                            className={TB.mapClass('btn btn-primary approve-btn', { 'disabled-edit-link': !canEditSOWForProject })}
                            disabled={this.props.isDisabled || this.props.isLocked}
                        >
                            Yes, everything looks correct
                            {!canEditSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                        </button>
                    </div>


                </div>

                <div className="summary-container">
                    {TB.map(steps, (step, i) => (
                        <div key={`step-${i}`} className="mb-4">
                            {React.createElement(step, {
                                ...this.props,
                                forReview: true
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

}